import { Dispatch, SetStateAction } from 'react';
import { post } from '../../../../scripts';
import { API } from '../../../../data/30pay.api';

export const requestReferralWithdrawal = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    data: {amount?: number},
    onComplete: () => void,
) => {
    setLoading(true)
    await post(API.referral.requestWithdrawal, data).then((response) => {
        setLoading(false)
        onComplete()
    }).catch((error) => {setLoading(false)})
}